import { UnmapTalkChannelTooltip } from './WebsiteTalkChannelItem'
import PropTypes from 'prop-types'

const TalkChannelItem = ({ name, enabled }) => (
  <span className="limit_line">
    {enabled !== 'Y' && <UnmapTalkChannelTooltip />}
    {name}
  </span>
)

TalkChannelItem.propTypes = {
  name: PropTypes.string,
  enabled: PropTypes.string,
}
export default TalkChannelItem
